<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加分区' : '修改分区'"
      center
      :visible="true"
      :before-close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      width="750px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        size="mini"
        style="width: 650px"
      >
        <el-form-item label="ID" prop="id">
          <el-input
            v-model.number="form.id"
            :disabled="!value.isCreate"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="被冠名">
          <el-switch
            v-model="form.isNamedByPlayer"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item label="标记为新区">
          <el-switch v-model="form.isNew" active-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item v-if="form.mergedIntoZoneId == ''" label="对外可见">
          <el-switch v-model="form.isVisible" active-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item v-if="form.mergedIntoZoneId == ''" label="维护中">
          <el-switch v-model="form.isInMaintenance" active-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item v-if="form.mergedIntoZoneId == '' && !form.isVisible" label="开始对外可见">
          <el-date-picker
            v-model="form.autoVisibleAfter"
            type="datetime"
            :clearable="false"
            placeholder="选择时间"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>        
        <el-form-item v-if="form.mergedIntoZoneId == ''" label="名义开服日期">
          <el-date-picker
            v-model="form.openAt"
            type="date"
            :clearable="false"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="form.mergedIntoZoneId == ''"
          label="游戏最低版本"
          prop="minVersion"
        >
          <el-input
            v-model="form.minVersion"
            clearable
            placeholder="无版本要求可不填。如果填了，则低于该版本将无法看到当前分区"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="对外地址（http）"
          prop="address"
          v-if="!$bizutil.isCloudNative() && form.mergedIntoZoneId == ''"
        >
          <el-input
            v-model="form.address"
            placeholder="举例：https://api.example.com/z1"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="反向代理地址"
          prop="proxyAddress"
          v-if="!$bizutil.isCloudNative() && form.mergedIntoZoneId == ''"
        >
          <el-input
            v-model="form.proxyAddress"
            placeholder="举例：127.0.0.1:11001，不要带http://或https://前缀，host部分暂仅支持ip、不支持域名（包括localhost）"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="对内GRPC地址"
          prop="internalAddress"
          v-if="!$bizutil.isCloudNative() && form.mergedIntoZoneId == ''"
        >
          <el-input
            v-model="form.internalAddress"
            placeholder="举例：127.0.0.1:11002，不要带http://或https://前缀"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="form.mergedIntoZoneId == ''"
          label="拥挤程度"
          prop="status"
        >
          <el-select
            v-model="form.status"
            placeholder="请选择"
            style="width: 130px"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose()">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const luxon = require("luxon");
// 本弹窗名称
const DialogName = "EditZoneDialog";

export default {
  data() {
    return {
      value: Object,
      form: {
        id: "",
        name: "",
        isNamedByPlayer: false,
        isNew: true,
        minVersion: "",
        address: "",
        proxyAddress: "",
        internalAddress: "",
        status: "",
        isVisible: false,
        isInMaintenance: false,
        mergedIntoZoneId: "",
        openAt: luxon.DateTime.now()
          .plus({ years: 1 })
          .startOf("day")
          .toMillis(), // 名义开服时间，默认是明天的今日
        autoVisibleAfter: luxon.DateTime.now()
          .plus({ years: 1 })
          .startOf("day")
          .toMillis(), // 何时自动解除隐藏，默认是明年的今日
      },
      rules: {
        id: [{ type: "number", required: true, message: " ", trigger: "blur" }],
        name: [{ required: true, message: " ", trigger: "blur" }],
        address: [
          {
            validator: (rule, value, callback) => {
              if (this.form.mergedIntoZoneId.trim() != "") {
                callback();
              } else {
                if (value.trim() == "") {
                  callback(new Error("不能为空"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
        internalAddress: [
          {
            validator: (rule, value, callback) => {
              if (this.form.mergedIntoZoneId.trim() != "") {
                callback();
              } else {
                if (value.trim() == "") {
                  callback(new Error("不能为空"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
      },
      statusOptions: [
        {
          value: 2,
          label: "流畅",
        },
        {
          value: 3,
          label: "爆满",
        },
      ],
    };
  },

  created() {
    this.value = this.$dialogutil.getData(DialogName).value;
    if (!this.value.isCreate) {
      // 编辑
      this.form.id = this.value.oldData.id;
      this.form.name = this.value.oldData.name;
      this.form.isNamedByPlayer = this.value.oldData.isNamedByPlayer;
      this.form.isNew = this.value.oldData.isNew;
      this.form.address = this.value.oldData.address;
      this.form.proxyAddress = this.value.oldData.proxyAddress;
      this.form.internalAddress = this.value.oldData.internalAddress;
      this.form.status = this.value.oldData.status;
      this.form.isVisible = this.value.oldData.isVisible;
      this.form.isInMaintenance = this.value.oldData.isInMaintenance;
      this.form.mergedIntoZoneId =
        this.value.oldData.mergedIntoZoneId == 0
          ? ""
          : this.value.oldData.mergedIntoZoneId;
      this.form.minVersion = this.value.oldData.minVersion;
      this.form.openAt = this.value.oldData.openAt;
      this.form.autoVisibleAfter = this.value.oldData.autoVisibleAfter;
      this.form.isMerging = this.value.oldData.isMerging;
    } else {
      // 新建或者复制
      this.form.status = 2; // 默认“流畅”状态
      this.form.isVisible = false; // 默认不对外可见
      this.form.isInMaintenance = false; // 默认不在维护中
      if (this.value.oldData != null) {
        // 复制
        // 新zone的id
        this.form.id = this.value.oldData.id + 1;

        if (this.$bizutil.isCloudNative()) {
          this.form.address = this.value.oldData.address.replace(
            /\d+$/,
            `${this.form.id - 1}`
          );
        } else {
          this.form.address = this.value.oldData.address.replace(
            /\d+$/,
            `${this.form.id}`
          );
        }

        this.form.name = this.value.oldData.name.replaceAll(
          this.value.oldData.id,
          this.form.id
        );

        if (this.$bizutil.isCloudNative()) {
          this.form.proxyAddress = this.value.oldData.proxyAddress.replace(
            /zone-gss-\d+/,
            `zone-gss-${this.form.id - 1}`
          );
        } else {
          let splits = this.value.oldData.proxyAddress.split(":");
          let ip = splits[0];
          let port = Number(splits[1]) + 2;

          this.form.proxyAddress = ip + ":" + port;
        }

        if (this.$bizutil.isCloudNative()) {
          this.form.internalAddress =
            this.value.oldData.internalAddress.replace(
              /zone-gss-\d+/,
              `zone-gss-${this.form.id - 1}`
            );
        } else {
          let splits = this.value.oldData.internalAddress.split(":");
          let ip = splits[0];
          let port = Number(splits[1]) + 2;

          this.form.internalAddress = ip + ":" + port;
        }

        this.form.minVersion = this.value.oldData.minVersion;
      }
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addZone();
      } else {
        this.updateZone();
      }
    },

    /**
     * 新增分区
     */
    addZone() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let zoneId = parseInt(this.form.id);
        if (zoneId.toString() != this.form.id || zoneId <= 0) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/manageZones`,
            {
              action: "create",
              create: {
                zone: {
                  id: zoneId,
                  name: this.form.name,
                  isNamedByPlayer: this.form.isNamedByPlayer,
                  isNew: this.form.isNew,
                  address: this.form.address,
                  proxyAddress: this.form.proxyAddress,
                  internalAddress: this.form.internalAddress,
                  status: this.form.status,
                  isVisible: this.form.isVisible,
                  isInMaintenance: this.form.isInMaintenance,
                  minVersion: this.form.minVersion.trim(),
                  openAt: this.form.openAt,
                  autoVisibleAfter: this.form.autoVisibleAfter,
                },
              }
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();
      });
    },

    /**
     * 修改分区
     */
    updateZone() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let mergedIntoZoneId = 0;
        if (this.form.mergedIntoZoneId != "") {
          mergedIntoZoneId = parseInt(this.form.mergedIntoZoneId);
          if (
            mergedIntoZoneId.toString() != this.form.mergedIntoZoneId ||
            mergedIntoZoneId < 0 ||
            mergedIntoZoneId == this.form.id
          ) {
            this.$alert("请检查输入", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }

        let address = this.form.address;
        let proxyAddress = this.form.proxyAddress;
        let internalAddress = this.form.internalAddress;

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/manageZones`,
            {
              action: "update",
              update: {
                zone: {
                  id: this.value.oldData.id,
                  name: this.form.name,
                  isNamedByPlayer: this.form.isNamedByPlayer,
                  isNew: this.form.isNew,
                  address: address,
                  proxyAddress: proxyAddress,
                  internalAddress: internalAddress,
                  status: this.form.status,
                  isVisible: this.form.isVisible,
                  isInMaintenance: this.form.isInMaintenance,
                  mergedIntoZoneId: mergedIntoZoneId,
                  minVersion: this.form.minVersion.trim(),
                  openAt: this.form.openAt,
                  autoVisibleAfter: this.form.autoVisibleAfter,
                },
              }
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();
      });
    },

    onClose(done) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>